<div class="dialog-call flex-column">
    <div mat-dialog-title class="dflex">
        <span> {{title}} </span>
        <button mat-icon-button style="float: right;"
            class="mat-focus-indicator close-button mat-icon-button mat-button-base" mat-dialog-close>
            <mat-icon class="mt-1 location_icon" color="primary">
                close
            </mat-icon>
        </button>
    </div>
</div>
<mat-divider></mat-divider>
<form>
    <div>
        <div class="row form-group">
            <div class="col-sm-8">
                <mat-form-field style="display:flex;flex-direction: column;margin-top: 10px;">
                    <input matInput required maxlength="150" placeholder="Search By Code or Description" name="code"
                        [(ngModel)]="searchText">
                </mat-form-field>
            </div>
            <div class="col-sm-4" style="padding-top: 18px;">
                <button mat-raised-button color="primary" (click)="searchInstitution()">
                    <mat-icon>search</mat-icon> Search
                </button>
                &nbsp;
                <button mat-dialog-close mat-raised-button>
                    Cancel
                </button>
            </div>
        </div>
    </div>
</form>
<div class="row">
    <div class="col-sm-12">
        <table mat-table matSort [dataSource]="dataSource" style="width: 100%;">
            <ng-container matColumnDef="code">
              <th mat-header-cell mat-sort-header *matHeaderCellDef> Code </th>
              <td mat-cell *matCellDef="let element">
                {{element.code}}
              </td>
            </ng-container>
            <ng-container matColumnDef="ncaacode">
              <th mat-header-cell mat-sort-header *matHeaderCellDef> NCAA Code </th>
              <td mat-cell *matCellDef="let element">
                {{element.ncaaCode}}
              </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell mat-sort-header *matHeaderCellDef> Description </th>
              <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>
            <ng-container matColumnDef="countryCode">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> Country Code </th>
                <td mat-cell *matCellDef="let element"> {{element.countryCode}} </td>
              </ng-container>
              <ng-container matColumnDef="stateCode">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> State Code </th>
                <td mat-cell *matCellDef="let element"> {{element.stateCode}} </td>
              </ng-container>
              <ng-container matColumnDef="isJuniorCollege">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> Is Junior College </th>
                <td mat-cell *matCellDef="let element"> {{element.isJuniorCollege ? 'Yes':'No'}} </td>
              </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns:displayedColumns;" (click)="getRecord(row)"></tr>
          </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
</div>